import React from 'react';
import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';

import type { AspectRatioProps } from './types';

const get_container_style = (aspectRatio: number) => css`
  height: 0;
  overflow: hidden;
  padding-top: ${100 / aspectRatio}%;
  background: var(--bg-primary);
  position: relative;
`;

const AspectRatio: React.FC<AspectRatioProps> = (props) => {
  const { aspectRatio = 1, children, ...restProps } = props;
  const container_style = React.useMemo(() => get_container_style(aspectRatio), [aspectRatio]);
  return (
    <Box {...restProps} className={cn(container_style, restProps.className)}>
      <Box className="absolute top-0 h-full w-full start-0">{children}</Box>
    </Box>
  );
};

export default AspectRatio;
